import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type LpnPageModel from './lpn-page.ts';
import type EnrichedContentModel from './enriched-content.ts';

export default class PageModel extends Model {
  @attr declare slug: string;
  @attr declare title: string;
  @attr declare kind: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('lpn-page', { async: false, inverse: 'lpn-page' })
  declare lpnPage: LpnPageModel;

  @hasMany('enriched-content', { async: false, inverse: 'page' })
  declare enrichedContents: EnrichedContentModel[];

  [Type] = 'page' as const;
}
